import React from 'react';
import { PageHeader } from 'antd';

const Management = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Управление и изменение"
            />
        </>
    );
};

export default Management;